import { ImgHTMLAttributes } from 'react';
import logo from '~/assets/images/logo.png';

export default function BaseImage(props: ImgHTMLAttributes<HTMLImageElement>) {
  const { alt = '', ...restProps } = props;
  if (!restProps.src) restProps.src = logo;

  return <img alt={alt} {...restProps} />;
}
